import apiClient from '../utils/apiClient';

/**
 * Authentication API Services
 * Quản lý đăng nhập, đăng xuất, thông tin người dùng và đổi mật khẩu
 */

export const authAPI = {
  /**
   * Đăng nhập hệ thống
   * @param {Object} credentials - Thông tin đăng nhập
   * @param {string} credentials.username - Tên đăng nhập
   * @param {string} credentials.password - Mật khẩu
   * @returns {Promise<Object>} Thông tin user và access token
   */
  login: async (credentials) => {
    const response = await apiClient.post({
      url: '/auth/login',
      data: credentials,
    });

    // Lưu token và thông tin user vào localStorage
    if (response.access_token && response.user) {
      const { setTokenToLocalStorage, setUserToLocalStorage } = await import('../utils/auth');
      setTokenToLocalStorage(response.access_token);
      setUserToLocalStorage(response.user);
    }

    return response;
  },

  /**
   * Lấy thông tin người dùng hiện tại
   * @returns {Promise<Object>} Thông tin chi tiết người dùng
   */
  getMe: async () => {
    return await apiClient.get({
      url: '/auth/me',
    });
  },

  /**
   * Đổi mật khẩu
   * @param {Object} passwordData - Dữ liệu đổi mật khẩu
   * @param {string} passwordData.currentPassword - Mật khẩu hiện tại
   * @param {string} passwordData.newPassword - Mật khẩu mới
   * @returns {Promise<Object>} Kết quả đổi mật khẩu
   */
  changePassword: async (passwordData) => {
    return await apiClient.put({
      url: '/auth/change-password',
      data: passwordData,
    });
  },

  /**
   * Đăng xuất hệ thống
   * @returns {Promise<Object>} Kết quả đăng xuất
   */
  logout: async () => {
    try {
      const response = await apiClient.post({
        url: '/auth/logout',
      });

      // Xóa tất cả thông tin auth khỏi localStorage
      const { clearAllAuthData } = await import('../utils/auth');
      clearAllAuthData();

      return response;
    } catch (error) {
      // Vẫn xóa token ngay cả khi API call thất bại
      const { clearAllAuthData } = await import('../utils/auth');
      clearAllAuthData();
      throw error;
    }
  },

  /**
   * Refresh token (nếu có)
   * @returns {Promise<Object>} Token mới
   */
  refreshToken: async () => {
    return await apiClient.post({
      url: '/auth/refresh-token',
    });
  },
};
